import React from 'react'
import styled from 'styled-components';

const MarginBottom= styled.div`
    margin-bottom: 30px;
`;
const ScheduleCard = (props) => {
    return (
        <>
            <MarginBottom className="row row-cols-1 row-cols-md-3 g-4">
                <div className="col">
                    <div className="card h-100">
                        <div className="card-body">
                            <h5 className="card-title">{props.Month}</h5>
                            <p className="card-text"><a href={props.Path} target="_blank">詳細はこちら(PDF)</a></p>
                        </div>
                    </div>
                </div>

                {/* propsの値が空の場合は表示させない */}
                {props.Month2 > '0' && 
                    <div className="col">
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">{props.Month2}</h5>
                                <p className="card-text"><a href={props.Path2} target="_blank">詳細はこちら(PDF)</a></p>
                            </div>
                        </div>
                    </div>
                }

                {/* propsの値が空の場合は表示させない */}
                {props.Month3 > '0' &&
                    <div className="col">
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">{props.Month3}</h5>
                                <p className="card-text"><a href={props.Path3} target="_blank">詳細はこちら(PDF)</a></p>
                            </div>
                        </div>
                    </div>
                }
            </MarginBottom>
        </>
    );
}

export default ScheduleCard;